<template>
  <div v-if="description" class="product-description">
    <div class="product-description__label">Опис продукту</div>
    <div
      class="product-description__text"
      :class="{ 'product-description__text--collapsed': isLong && !isExpanded }"
      v-html="formattedDescription"
    ></div>
    <button
      v-if="isLong"
      type="button"
      class="product-description__toggle"
      @click="isExpanded = !isExpanded"
    >
      {{ isExpanded ? 'Згорнути' : 'Показати повністю' }}
    </button>
  </div>
</template>

<script>
import { formatRichText } from '@/shared/lib/string';

const COLLAPSE_MIN_LENGTH = 600;
const COLLAPSE_MIN_LINES = 8;

export default {
  name: 'ProductDescription',
  props: {
    description: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    formattedDescription() {
      return formatRichText(this.description);
    },
    isLong() {
      return this.description.length > COLLAPSE_MIN_LENGTH
        || this.description.split('\n').length > COLLAPSE_MIN_LINES;
    },
  },
};
</script>

<style scoped lang="scss">
.product-description {
  margin-top: 16px;
  padding: 16px 18px;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: linear-gradient(180deg, #f8fbff 0%, #f0f7ff 100%);
  text-align: left;

  &__label {
    margin-bottom: 6px;
    color: #0f172a;
    font-size: 15px;
    line-height: 1.4;
    font-weight: 600;
  }

  &__text {
    color: #475569;
    font-size: 14px;
    line-height: 1.5;
    word-break: break-word;

    &--collapsed {
      max-height: 168px;
      overflow: hidden;
      -webkit-mask-image: linear-gradient(180deg, #000 60%, transparent 100%);
      mask-image: linear-gradient(180deg, #000 60%, transparent 100%);
    }

    // Сторінки пропозицій мають глобальні правила для p / ul / li всередині
    // .details__params__list і .details__list (жирний 18px, свої маркери списку),
    // тому перебиваємо їх через !important.
    ::v-deep p,
    ::v-deep ul,
    ::v-deep ol {
      margin: 0 0 8px !important;
      padding: 0;
      max-width: none !important;
      color: inherit !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 1.5 !important;

      &:last-child {
        margin-bottom: 0 !important;
      }
    }

    ::v-deep ul,
    ::v-deep ol {
      padding-left: 20px !important;
      margin-left: 0 !important;
    }

    ::v-deep ul {
      list-style: disc !important;
    }

    ::v-deep ol {
      list-style: decimal !important;
    }

    ::v-deep li {
      display: list-item !important;
      margin: 0 0 4px !important;
      color: inherit !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 1.5 !important;

      &::before {
        content: none !important;
      }
    }

    ::v-deep strong,
    ::v-deep b {
      font-weight: 700;
    }

    ::v-deep em,
    ::v-deep i {
      font-style: italic;
    }

    ::v-deep u {
      text-decoration: underline;
    }

    ::v-deep s {
      text-decoration: line-through;
    }

    ::v-deep a {
      color: #0a77ff;
      text-decoration: underline;
    }
  }

  &__toggle {
    margin-top: 8px;
    padding: 0;
    border: none;
    background: none;
    color: #0a77ff;
    font-size: 14px;
    line-height: 1.4;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
